import React, { Component } from 'react';

const year = new Date().getFullYear();

class Footer extends Component {
    render() {
        return (
            <div>
                <hr />
                <div className="flex items-center mb2">
                    <p className="my0">© Alan Honey Photography, {year}</p>
                    <div className="flex-auto" />
                    <p className="my0">
                        Website by{' '}
                        <a href="https://tibfib.com" target="_blank" rel="noopener noreferrer">
                            Tibfib
                        </a>
                    </p>
                </div>
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/core/components/Footer.js